import { render, staticRenderFns } from "./twofactorexplanation.vue?vue&type=template&id=85b8c542&"
import script from "./twofactorexplanation.js?vue&type=script&lang=js&"
export * from "./twofactorexplanation.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85b8c542')) {
      api.createRecord('85b8c542', component.options)
    } else {
      api.reload('85b8c542', component.options)
    }
    module.hot.accept("./twofactorexplanation.vue?vue&type=template&id=85b8c542&", function () {
      api.rerender('85b8c542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/login/components/twofactorexplanation.vue"
export default component.exports